import styled from 'styled-components'

export const StyledInputsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-end;
`
